(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lockt-native-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lockt-native-bundle')) {
  customElements.define('lockt-native-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const configNode = this.querySelector('[data-config]');
      if (!configNode) return;
      this.initialized = true;
      this.config = JSON.parse(configNode.textContent);
      this.selection = 'kit';
      this.busy = false;
      this.uncertain = false;
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      this.groups = {night:['night'],duo:['night','day'],kit:['night','day','case','strips']};
      this.querySelectorAll('input[type="radio"]').forEach(input => {
        input.addEventListener('change', () => this.select(input.value));
      });
      this.button.addEventListener('click', () => this.add());
      this.select('kit');
    }
    select(key) {
      if (this.busy || !this.groups[key]) return;
      this.selection = key;
      this.querySelectorAll('[data-option]').forEach(option => {
        const selected = option.dataset.option === key;
        option.querySelector('input').checked = selected;
        option.querySelector('.lockt-details').hidden = !selected;
      });
      this.querySelector('[data-selected-name]').textContent = this.querySelector('[data-option="'+key+'"] .lockt-name').textContent;
      const {variants, messages} = this.config;
      let message = '';
      if (!this.config.enabled) message = messages.pending;
      else if (this.config.currency !== 'USD' || variants.night.price !== 4900 || variants.day.price !== 4900) message = messages.price;
      else if (this.groups[key].some(k => !variants[k].id || !variants[k].available)) message = messages.unavailable;
      if (this.uncertain) message = messages.error;
      this.status.textContent = message;
      this.button.disabled = Boolean(message);
    }
    async json(url, options) {
      const response = await fetch(url, {credentials:'same-origin',...options});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.config.messages.error);
      return data;
    }
    async add() {
      if (this.busy || this.button.disabled || this.uncertain) return;
      const config = this.config;
      const keys = this.groups[this.selection];
      const prefix = config.root.endsWith('/') ? config.root : config.root + '/';
      const inputs = this.querySelectorAll('input[type="radio"]');
      let submitted = false;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = config.messages.adding;
      this.button.setAttribute('aria-busy', 'true');
      inputs.forEach(input => {input.disabled = true;});
      this.status.textContent = '';
      try {
        const handles = [...new Set(keys.map(k => config.variants[k].handle))];
        const products = await Promise.all(handles.map(handle => this.json(prefix+'products/'+encodeURIComponent(handle)+'.js')));
        for (const key of keys) {
          const variant = products.flatMap(p => p.variants).find(v => v.id === config.variants[key].id);
          if (!variant || !variant.available) throw new Error(config.messages.unavailable);
          if ((key === 'night' || key === 'day') && variant.price !== 4900) throw new Error(config.messages.price);
        }
        const groupId = crypto.randomUUID();
        const items = keys.map(key => ({id:config.variants[key].id,quantity:1,properties:{_lockt_bundle:groupId,_lockt_offer:this.selection}}));
        submitted = true;
        await this.json(prefix+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        const cart = await this.json(prefix+'cart.js');
        const added = cart.items.filter(item => item.properties?._lockt_bundle === groupId);
        const valid = cart.currency === 'USD' && keys.every(key => {
          const lines = added.filter(item => item.variant_id === config.variants[key].id);
          const expected = key === 'night' || key === 'day' ? 4900 : 0;
          return lines.reduce((sum,item) => sum+item.quantity,0) === 1 && lines.reduce((sum,item) => sum+item.final_line_price,0) === expected;
        });
        if (!valid) throw new Error(config.messages.mismatch);
        window.location.assign(config.cartUrl);
      } catch (error) {
        this.uncertain = submitted;
        this.status.textContent = error.message || config.messages.error;
        this.querySelector('[data-cart-link]').hidden = !submitted;
        this.button.disabled = submitted;
      } finally {
        this.busy = false;
        this.button.textContent = config.messages.add;
        this.button.removeAttribute('aria-busy');
        inputs.forEach(input => {input.disabled = false;});
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
